import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const savedSearchTabEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-object-class-view-saved-search-tab" */ './ui'),
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
